import { createSlice } from '@reduxjs/toolkit';

const initialImgCodeState = { img: null };

const imageSlice = createSlice({
  name: 'img',
  initialState: initialImgCodeState,
  reducers: {
    store(state, action) {
      state.img = action.payload;
    },
    reset(state, action){
      state.img = null;
    }
  }
});

export const imageActions = imageSlice.actions;

export default imageSlice.reducer;